import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=4ec3c0ec&scoped=true"
import script from "./bargain.vue?vue&type=script&lang=ts"
export * from "./bargain.vue?vue&type=script&lang=ts"
import style0 from "./bargain.vue?vue&type=style&index=0&id=4ec3c0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec3c0ec",
  null
  
)

export default component.exports